export default __webpack_public_path__ + "static/media/skills.aee24eb6.svg";